export const DateFormats = {
    DEFAULT: 'D-MMM-YYYY',
    SECONDARY: 'YYYY-MM-DD'
};